import { jsx as i } from "react/jsx-runtime";
import c from "clsx";
import { useRef as l, useState as f, useLayoutEffect as m } from "react";
import n from "../Modal.module.css.js";
const u = (r) => {
  const [s, o] = f(!1);
  return m(() => {
    const { current: e } = r;
    if (!e)
      return;
    const t = new ResizeObserver(() => {
      o(e.scrollHeight > e.clientHeight);
    });
    return t.observe(e), () => {
      t.disconnect();
    };
  }, [r]), s;
}, d = ({ children: r, className: s }) => {
  const o = l(null), e = u(o);
  return /* @__PURE__ */ i(
    "div",
    {
      ref: o,
      className: c(n.main, s, {
        [n.mainOverFlow]: e
      }),
      children: r
    }
  );
};
export {
  d as ModalBody,
  u as useIsOverflow
};
//# sourceMappingURL=ModalBody.js.map
